// types.ts
export enum TaskType {
  DECODER = "DECODER",
  LOREKEEPER = "LOREKEEPER",
  SIGNAL_BOOSTER = "SIGNAL_BOOSTER",
  FEED_WATCHER = "FEED_WATCHER",
  NETWORKING_EVENT = "NetworkingEvent",
  UI_UX_ARCHITECT = "UI/UX Architect",
  INTERFACE_ARCHITECT = "Interface Architect",
  SYSTEM_BUILDER = "System Builder",
  // CATCH_UP = "CatchUp",
}

export interface Item {
  _id: string;
  name: string;
  description: string;
  price: number;
  stickerPackUrl?: string;
  image: string;
  stock?: number;
}

export interface UserData {
  _id: string;
  telegramId: number;
  uid: string;
  username?: string;
  profilePicture?: string;
  lastBonusGrantedDate?: Date; // <-- ADD THIS
  points: number;
  lifelineTime: number;
  lastActivityAt?: Date;

  dailyStreak: number;
  lastStreakDate?: Date;

  completedTasks: {
    taskType: TaskType;
    title?: string;
    description?: string;
    xpReward: number;
    timeReward: number;
    taskId?: string;
    completedAt?: Date;
  }[];

  pointsHistory: {
    reason: string;
    date: Date;
    points: number;
    lifelineTime: number;
  }[];

  inactivityWarningsSent: number;
  isUnderPenalty: boolean;
  penaltyStartedAt?: Date;
  catchUpAvailable: boolean;

  instagramHandle?: string;
  twitterHandle?: string;
  linkedInHandle?: string;
  facebookHandle?: string;
  tikTokHandle?: string;
  discordHandle?: string;
  socialMediaMessageId?: number | null;

  walletAddress?: string;

  lastLoginDate: Date;
  lifetimeLoginDays: number;

  logs: {
    date: Date;
    message: string;
  }[];
  // NEW ADDITION: Add the inventory field
  inventory: Item[];
  banned: boolean;
  banReason?: string;
  role: "user" | "admin";

  createdAt: Date;
  updatedAt: Date;
}

export interface Task {
  _id?: string;
  title: string;
  description: string;
  type: TaskType;
  xpReward: number;
  messageId?: number;
  timeReward: number;
  isActive: boolean;
  link?: string;
  answer?: string;
  isAnswerImage?: boolean;
  endDate?: Date;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface Friend {
  username?: string;
  score: number;
  avatar: string | undefined;
  rank?: number;
}

export interface LeaderboardEntry {
  id: number;
  username?: string;
  profilePicture?: string;
  points: number;
}

export interface Leaderboard {
  entries: {
    alltime: LeaderboardEntry[];
    weekly: LeaderboardEntry[];
    daily: LeaderboardEntry[];
  };
  lastUpdates: number;
  userRank: number;
}

// Define the overall state structure
export interface RootState {
  userData: UserData;
  leaderboard: Leaderboard;
  tasks: Task[];
  friends: Friend[];
}
